export default "__VITE_PUBLIC_ASSET__b01cafab__"